import React from 'react';

import { PaymentMode, TransactionType } from '@portal/models/enumerators';
import { getRouteStackPath } from '@portal/config/routes';
import { payment } from '@portal/config/app.json';
import { sendEvent } from '@portal/services/firebase';
import { EventType } from '@portal/enum/analytics';
import { translate } from '@portal/services/i18n';

import ReceiveIcon from '@portal/assets/svg/home-buttons/ic_receive.svg?react';
import ManualIcon from '@portal/assets/svg/home-buttons/ic_transfer.svg?react';
import PaymentLinkIcon from '@portal/assets/svg/home-buttons/ic_loan.svg?react';

import IconCard from '@portal/components/IconCard/IconCard';
import AccessListControl from '@portal/components/AccessListControl/AccessListControl';
import RolesType from '@portal/enum/rolesType';
import useReduxState from '@portal/hooks/useReduxState';

type ReceivableButtonsProps = {
  setManualPaymentModal: (state: {
    visible: boolean;
    type: TransactionType | null;
  }) => void;
  openMaintenance: () => void;
};

const ReceivableButtons = ({
  setManualPaymentModal,
  openMaintenance,
}: ReceivableButtonsProps) => {
  const {
    settings: { remoteConfig },
  } = useReduxState();

  return (
    <div className="account-receivable__container__options">
      {payment.fileReceivable ? (
        <AccessListControl accessRole={RolesType.RECEIVABLE_CREATE_FILE}>
          <div className="account-receivable__container__options__icon-card">
            <IconCard
              text={translate('PAGES.PAYMENT.ACCOUNT_RECEIVABLE.BUTTONS.FILE')}
              icon={
                <ReceiveIcon
                  className="account-receivable__container__options__icon-card__icon"
                  width={30}
                  height={30}
                />
              }
              link={
                remoteConfig?.disableCashIn
                  ? undefined
                  : getRouteStackPath('FILES_HANDLER', 'GENERATE_BY_FILE')
              }
              linkData={{
                mode: PaymentMode.RECEIVABLE,
              }}
              onClick={
                remoteConfig?.disableCashIn
                  ? () => openMaintenance()
                  : undefined
              }
            />
          </div>
        </AccessListControl>
      ) : null}
      {payment.manualReceivableBillet ||
      payment.manualReceivableBilletPix ||
      payment.manualReceivablePix ? (
        <AccessListControl accessRole={RolesType.RECEIVABLE_CREATE_BILLET}>
          <div className="account-receivable__container__options__icon-card">
            <IconCard
              text={translate(
                'PAGES.PAYMENT.ACCOUNT_RECEIVABLE.BUTTONS.MANUAL'
              )}
              icon={
                <ManualIcon
                  className="account-receivable__container__options__icon-card__icon"
                  width={30}
                  height={30}
                />
              }
              onClick={
                remoteConfig?.disableCashIn
                  ? () => openMaintenance()
                  : () => {
                      setManualPaymentModal({
                        visible: true,
                        type: null,
                      });
                      sendEvent(EventType.BUTTON_RECEIVABLE_MANUAL);
                    }
              }
            />
          </div>
        </AccessListControl>
      ) : null}
      {payment.receivablePaymentLink ? (
        <AccessListControl accessRole={RolesType.RECEIVABLE_CREATE_LINK}>
          <div className="account-receivable__container__options__icon-card">
            <IconCard
              text={translate(
                'PAGES.PAYMENT.ACCOUNT_RECEIVABLE.BUTTONS.PAYMENT_LINK'
              )}
              icon={
                <PaymentLinkIcon
                  className="account-receivable__container__options__icon-card__icon"
                  width={30}
                  height={30}
                />
              }
              onClick={
                remoteConfig?.disableCashIn
                  ? () => openMaintenance()
                  : () => {
                      setManualPaymentModal({
                        visible: true,
                        type: TransactionType.PAYMENT_LINK,
                      });
                      sendEvent(EventType.BUTTON_RECEIVABLE_PAYMENT_LINK);
                    }
              }
            />
          </div>
        </AccessListControl>
      ) : null}
    </div>
  );
};

export default ReceivableButtons;
